// extracted by mini-css-extract-plugin
module.exports = {"Bar":"ProgressBar_Bar__2l136","Percentage":"ProgressBar_Percentage__1zlMc"};